import { FC } from "react";
import { atlasRoutes } from "@/app/router/routes";
import { localStorageModule } from "@/modules/local-storage";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAtlasAuthContext } from "@/contexts/atlas-auth";
import { SidebarLayout } from "@/app/layout/sidebar-layout";

export const RequireAtlasAuthOutlet: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { authContext } = useAtlasAuthContext();

  const hasSufficientAuth = authContext.isAuthenticated;

  useEffect(() => {
    if (hasSufficientAuth) {
      return;
    }

    /**
     * We redirect them to the /login page, but save the current location they were
     * trying to go to when they were redirected. This allows us to send them
     * along to that page after they login, which is a nicer user experience
     * than dropping them off on the home page.
     */
    const asyncLogic = async () => {
      await localStorageModule.writePendingRedirectPath({
        pathname: location.pathname,
      });

      /**
       * Using this because we don't have access to the `navigation` store when
       * on a public route.
       */
      navigate(atlasRoutes.logIn({}).path, { replace: true });
    };

    asyncLogic();
  }, [location.pathname, navigate, hasSufficientAuth]);

  if (!hasSufficientAuth) {
    return null;
  }

  return (
    <SidebarLayout>
      <Outlet />
    </SidebarLayout>
  );
};
